import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  documentTypes: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the documentTypes
export const fetchDocumentTypes = createAsyncThunk(
  "fetchDocumentTypes/documentTypes",
  async ({ enqueueSnackbar, limit, page, filter }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`settings/documents/types`, {
        params: {
          page: page + 1,
          limit,
          filter,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create documentTYpe
export const createDocumentType = createAsyncThunk(
  "createDocumentType/documentTypes",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(
        `settings/documents/types`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update documentTYpe
export const updateDocumentType = createAsyncThunk(
  "updateDocumentType/documentTypes",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `settings/documents/types/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete documentTYpe
export const deleteDocumentType = createAsyncThunk(
  "deleteDocumentType/documentTypes",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/documents/types/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const documentTypeslice = createSlice({
  name: "documentTYpe",
  initialState,
  extraReducers: (builder) => {
    // TODO: create documentTYpe
    builder.addCase(fetchDocumentTypes.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchDocumentTypes.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      state.documentTypes = action.payload;
    });

    builder.addCase(fetchDocumentTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create documentTYpe
    builder.addCase(createDocumentType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createDocumentType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.documentTypes.data = [
        action.payload.data,
        ...state.documentTypes.data,
      ];
      state.documentTypes.meta.total = state.documentTypes.meta.total + 1;
      action.payload.enqueueSnackbar("DocumentTYpe is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createDocumentType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update documentTYpe
    builder.addCase(updateDocumentType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateDocumentType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.documentTypes.data = state.documentTypes.data.map(
        (documentTYpe) => {
          if (documentTYpe.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return documentTYpe;
          }
        }
      );
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          "DocumentTYpe is updated successfully.",
          {
            variant: "success",
          }
        );
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateDocumentType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(
            action.payload.error ||
              action.payload.error.errors ||
              action.payload.error.message
          ),
          {
            variant: "error",
          }
        );
    });

    // TODO: delete documentTYpe
    builder.addCase(deleteDocumentType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteDocumentType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.documentTypes.data = state.documentTypes.data.filter(
        (documentTYpe) => documentTYpe.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("DocumentTYpe is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteDocumentType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default documentTypeslice.reducer;
